import React, { useState } from "react";
import HeaderName from "../../HeaderName";
import SideBar from "../../SideBar";
import Breadcrumb from "../../../common/Breadcrumb";
import { useParams } from "react-router-dom";
import { Box, Tab, Tabs } from "@mui/material";
import ProductItemUnitList from "./ProductItemUnitList";
import ProductItemUnitForm from "./ProductItemUnitForm";
import UnitRelation from "./UnitRelation";
import UnitConvertion from "./UnitConvertion";
import ProductItemUnitHeader from "./ProductItemUnitHeader";


const ProductItemUnit = () => {
  const { id } = useParams();
  const [value, setValue] = useState(0);

  const TAB_TYPES = [
    { label: "HO", type: "ho" },
    { label: "Branch", type: "branch" },
  ];

  const handleChange = (e, newValue) => {
    setValue(newValue);
  };

  console.log(value);

  return (
    <div classNameName="App">
      <div className="wrapper">
        <HeaderName />

        {/* <!-- /.navbar --> */}

        {/* <!-- Main Sidebar Container --> */}
        <SideBar />

        {/* <!-- Content Wrapper. Contains page content --> */}
        <div className="content-wrapper">
          {/* <!-- Content Header (Page header) --> */}
          <div className="content-header">
            <div className="container-fluid">
              <div className="row">
                <div className="col-sm-12">
                  <Breadcrumb
                    currentPage="Item Unit Lists"
                    links={[
                      {
                        title: "Product Lists",
                        path: "/product_list",
                      },
                      {
                        title: "Product Items",
                        path: `/unit/${id}`,
                      },
                    ]}
                  />
                </div>
              </div>
            </div>
          </div>

          {/* <!-- Main content --> */}

          <section className="content">
            <div className="container-fluid">
              <div className="row d-flex justify-content-between">
                <div className="col-md-6">
                  {/* <h4>Medicine Item List</h4> */}
                </div>
              </div>
              <div className="row">
                <ProductItemUnitHeader />
                {/* tab */}
                {/* <Box>
                  <Tabs value={value} onChange={handleChange}>
                    {TAB_TYPES.map((tab, index) => (
                      <Tab key={index} label={tab.label} />
                    ))}
                  </Tabs>

                  <Box p={2}>
                   
                    <p>Item Unit Lists</p>
                  </Box>
                </Box> */}
                <ProductItemUnitForm />
                <ProductItemUnitList />

                {/* <div className="col-md-8">
                  <ProductItemUnitList />
                </div>
                <div className="col-md-4">
                  <ProductItemUnitForm />
                </div> */}
                <div>
                  <UnitRelation />
                </div>
                <div>
                  <UnitConvertion />
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>

      {/* <!-- /.content-wrapper --> */}
      <footer className="main-footer" style={{ marginTop: "50px;" }}>
        <strong>
          Copyright &copy; 2017-2020{" "}
          <a href="http://www.kwintechnologies.com">K-win Technology</a>.
        </strong>
        All rights reserved.
      </footer>

      {/* <!-- Control Sidebar --> */}
      <aside className="control-sidebar control-sidebar-dark">
        {/* <!-- Control sidebar content goes here --> */}
      </aside>

      {/* <!-- ./wrapper --> */}
    </div>
  );
};

export default ProductItemUnit;
